require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/es7.symbol.observable.js
// module id = EcP+
// module chunks = 0